import SectionSkeleton from "./SectionSkeleton";

export default SectionSkeleton;
